<template>
  <div class="manager_dashboard">
    <UserMenu></UserMenu>
    <div class="wrapper">
      <ManagerSidebarMenu v-if="checkIsManager() || ($store.state.switch_flag == 'Manager')" :show_menu="false" :show_back_button="true"></ManagerSidebarMenu>
      <MentorSidebarMenu v-if="checkIsMentor() || ($store.state.switch_flag == 'Mentor')" :show_menu="false" :show_back_button="true"></MentorSidebarMenu>
      <div class="content-wrapper" style="padding-left: 165px;">
        <div class="container-wrapper center">
          <div class="row">
            <div class="col-6">
              <div class="row mb-4 mt-3 align-items-end">
                <div class="col-7 col-xl-6 pl-4">
                  <div class="h3 d-inline mr-2 text-uppercase">{{ menteeShortName }}</div>
                </div>
                <div class="col-5 col-xl-6 pr-4 text-right">
                  &nbsp;
                </div>              
              </div>


              <div>
                <div class="mt-1 mb-3 pl-3 pr-3">
                  <div class="row align-items-end">
                    <div class="col px-2 text-center" v-for="(pathwayStep, index) in pathwayStepsData.mentee_pathway_steps">
                      <p class="text-uppercase mb-1 " 
                        :class="activeStep == pathwayStep.id ? 'pw_step_title_active' : 'pw_step_title'" @click="moveToStep(pathwayStep.id)" style="cursor: pointer;">
                        <span :style="activeStep == pathwayStep.id ? 'background-color: ' + pathwayStepsData.mentee_pathway.ascentColor + ';' : ''">{{ pathwayStep.stepTitle }}</span>
                      </p>
                      <div class="progress progress_pathway">
                        <div class="progress-bar progress_bar_100" :style="'width:' + pathwayStep.percentage_completion + '%;'"></div>
                      </div>
                    </div>        
                  </div>
                </div>
              </div>

              <div class="pl-2 pr-2">
                <div class="text-muted">Mentor(s)</div>
                  <ul class="list-inline">
                    <li class="list-inline-item font-weight-bold" v-for="(mentorAssigned, index) in mentorsAssigned" :key="index">{{ mentorAssigned.name }}</li>
                  </ul>                
              </div>

              <div v-if="activeStep != ''">
                <MenteeProgress
                  :menteeId="menteeId"
                  :stepId="activeStep"
                  :pathwayId="pathwayId"
                  :type="2"
                  ref="MenteeProgressComponent"
                  @closeAddRep="closeAddRep"
                  >
                </MenteeProgress>
              </div>

            </div>
            <div class="col-6 pl-3 pr-5">
              <div class="row mb-2 mt-3" v-if="repCount > 0">
                <div class="col-6 pl-4">
                  <div v-if="repCount == 1" class="text-uppercase font-weight-bold">{{ repCount }} Rep to Review</div>
                  <div v-else class="text-uppercase font-weight-bold">{{ repCount }} Reps to Review</div>
                </div>
                <div class="col-6 pr-4 text-right">
                  <div class="font-weight-bold text-uppercase" v-if="repTasks.length > 1"><a class="help-txt branding_text_color" href="#" @click.prevent="toggleViewAll">{{ viewAll ? 'View Less' : 'View All' }}</a></div>
                </div>              
              </div>

              <b-alert
                :show="dismissCountDown"
                dismissible
                variant="success"
                @dismissed="dismissCountDown=0"
                @dismiss-count-down="countDownChanged"
                >
                {{ success_message }}
              </b-alert>

              <MenteeRepReview 
                v-for="(repTask, index) in repTasks" :key="repTask.repId"
                :repTask="repTask" 
                :menteeFirstName="menteeFirstName"
                :menteeShortName="menteeShortName"
                :menteeId = "menteeId"
                alignApproveDenyBtns="type2"
                repReviewType="menteePage"
                @reduceRepCount="reduceRepCount"
                @removeRepTask="removeRepTask"          
                v-if="index === 0 || viewAll"
              ></MenteeRepReview>

              <MenteeTasksLogged
                :menteeId="menteeId"
                ></MenteeTasksLogged>

            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import axios from 'axios';
import UserMenu from '../shared/user_menu.vue';
import ManagerSidebarMenu from '@/components/shared/manager_sidebar_menu.vue';
import MenteeProgress from '@/components/manager/mentee_progress.vue';
import MenteeRepReview from '@/components/manager/mentee_rep_review.vue';
import MenteeTasksLogged from '@/components/manager/mentee_tasks_logged.vue';
import MenteePathwayProgress from '@/components/manager/mentee_pathway_progress.vue';
import MentorSidebarMenu from '@/components/shared/mentor_sidebar_menu.vue';
import { checkIsManager, checkIsMentor } from '@/components/shared/utils.js';
import router from '../../router/index.js';

export default {
  data() {
    return {
      menteeId: '',
      menteeShortName: '',
      repCount: '',
      menteeFirstName: '',
      mentorsAssigned: [],
      menteeFlag: 'Mentee',
      repTasks: [],
      viewAll: false,
      pathwayStepsData: [],
      activeStep: '',
      pathwayId: '',
      showFutureSteps: false,
      success_message: '',
      dismissCountDown: 0,
    }
  },
  computed: {
    
  },
  components: {
    UserMenu,
    ManagerSidebarMenu,
    MentorSidebarMenu,
    MenteeProgress,
    MenteeRepReview,
    MenteeTasksLogged,
    MenteePathwayProgress,
  },
  methods: {
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    closeAddRep() {

    },
    checkIsMentor() {
      return checkIsMentor();
    },
    checkIsManager() {
      return checkIsManager();
    },
    toggleViewAll() {
      this.viewAll = !this.viewAll;
    },
    moveToStep(stepId) {
      if(this.showFutureSteps == true) {
        this.activeStep = stepId;
        this.$refs.MenteeProgressComponent.reloadStep(stepId);
      }
    },
    openMenteeAddRepModal(event) {
      event.preventDefault();
      event.stopPropagation();
      this.$refs.menteeAddRepModal.show();
    },
    closeMenteeAddRepModal() {
      this.$refs.menteeAddRepModal.hide();
    },
    reduceRepCount() {
      this.success_message = 'Rep reviewed successfully.';
      this.dismissCountDown = 5;
      this.repCount = this.repCount - 1;

      this.$emit('reduceRepCount', {
        menteeId: this.menteeId,
        repCount: this.repCount,
      });
      
      if (this.repCount == 0) {
        this.$emit('close-right-panel-modal');
      }
    },
    removeRepTask(repTaskId) {
      const index = this.repTasks.findIndex(item => item.repId === repTaskId);
      if (index !== -1) {
        this.repTasks.splice(index, 1);
      }
    },
  },
  created() {
    this.menteeId = this.$route.params.mentee_id;
    axios('/desktop/get-mentee-repitition-lists-all-tasklists', {
      method: 'GET',
      params: {
        mentee_id: this.menteeId,
        accountId: this.$store.state.user_accountid, 
      }
    })
    .then(resp => {
      let data = resp.data;
      this.menteeFirstName = data.mentee_first_name;
      this.menteeShortName = data.mentee_short_name;
      this.repCount = data.rep_count;
      this.repTasks = data.rep_tasks;
      this.mentorsAssigned = data.mentors_assigned;
    })
    .catch(() => {});
    axios('/desktop/v2/get-mentee-details', {
      method: 'GET',
      params: {
        mentee_id: this.menteeId,
        accountId: this.$store.state.user_accountid, 
      }
    })
    .then(resp => {
      let data = resp.data;
      this.menteeFirstName = data.mentee_first_name;
      this.menteeShortName = data.mentee_short_name;
      this.repCount = data.rep_count;
      this.mentorsAssigned = data.mentors_assigned;
      this.menteeFlag = data.mentee_flag;
    })
    .catch(() => {});

    axios('/desktop/v2/pathway/get-mentee-pathway-progress', {
      method: 'GET',
      params: {
        account_id: this.$store.state.user_accountid, 
        mentee_id: this.menteeId, 
      }
    })
    .then(resp => {
      let data = resp.data;
      this.pathwayStepsData = data;
      this.activeStep = this.pathwayStepsData.mentee_pathway.currentStep;
      this.pathwayId = this.pathwayStepsData.mentee_pathway.id;
      this.showFutureSteps = this.pathwayStepsData.mentee_pathway.showFutureSteps;
    })
    .catch(() => {});




  },
  mounted() {

  }
}
</script>

<style>
@import '../../assets/styles/style_v2.css';
</style>

<style scoped>
@media (max-width: 1199.98px) {
  .container-wrapper {
    width: 95%;
  }
}
.mentee_title_btn {
  background-color: #b3e6fa;
  padding: 2px 10px;
  border-radius: 8px;
  font-size: 12px;
  color: #2d6074;
  border: 0;
  margin-top: -12px;
}
input:focus, select:focus, textarea:focus, button:focus {
  border-color: #ced4da;
}
.progress_pathway {
  height:5px;
  margin-top: 5px;
}
.pw_step_title {
  font-size: 12px;
}
.pw_step_title_active {
  font-size: 12px;
}
.pw_step_title_active span {
  color: #FFFFFF;
  padding: 0px 6px;
  border-radius: 4px;
  display: inline-block;
}
.reps_review_icon {
  width: 15px;
  margin-left: 4px;
  margin-top: -5px;
}
</style>


// WEBPACK FOOTER //
// src/components/manager/view_mentee_profile_new.vue